<div class="spinner-overlay" *ngIf="utils.showLoader">
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
</div> 